/**
 * A new transfer. Nothing is written — and no STDN number is spent — until the first Post.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { TransferPage } from "@/features/dispatch-stock-transfer/components/transfer-page";

export const Route = createFileRoute("/_app/dispatch/stock-transfer/new")({
  beforeLoad: () => {
    if (!useAuth.getState().can("document.create"))
      throw redirect({ to: "/dispatch/stock-transfer" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <TransferPage
      transfer={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
